import React from 'react';
import { Lock, ArrowRight } from 'lucide-react';
import { getToken } from '../utils/apiFetch';
import { detectLang } from '../utils/langState';

export const BACKOFFICE_URL = 'https://my.thedcaclub.com';
const ALLOWED_HOST = 'my.thedcaclub.com';
const ACCESS_KEY = 'sim360_backoffice_access';
const ACCESS_TTL_MS = 24 * 60 * 60 * 1000;

const COPY = {
  es: { title: 'Acceso reservado a miembros', body: 'El Simulador 360° solo está disponible desde el backoffice de The DCA Club.', cta: 'Ir al backoffice' },
  fr: { title: 'Accès réservé aux membres', body: "Le Simulateur 360° est accessible uniquement depuis le backoffice de The DCA Club.", cta: 'Aller au backoffice' },
  en: { title: 'Members-only access', body: 'Simulator 360° is only available from The DCA Club backoffice.', cta: 'Go to the backoffice' },
};

const cameFromBackoffice = () => {
  try {
    return new URL(document.referrer).hostname === ALLOWED_HOST;
  } catch {
    return false;
  }
};

export const hasAccess = () => {
  try {
    if (cameFromBackoffice()) {
      localStorage.setItem(ACCESS_KEY, String(Date.now()));
      return true;
    }
    if (getToken()) return true;
    const ts = Number(localStorage.getItem(ACCESS_KEY));
    return Boolean(ts) && Date.now() - ts < ACCESS_TTL_MS;
  } catch {
    return cameFromBackoffice();
  }
};

export const AccessDenied = () => {
  const c = COPY[detectLang()] || COPY.en;
  return (
    <div className="min-h-screen bg-[#020817] flex items-center justify-center px-6" data-testid="access-denied-page">
      <div className="max-w-md w-full text-left border border-[#0b1c38] bg-[#040816] rounded-2xl p-8 shadow-[0_0_60px_-20px_rgba(0,229,255,0.5)]">
        <div className="w-12 h-12 rounded-full bg-[#00e5ff]/10 border border-[#00e5ff]/40 flex items-center justify-center mb-6">
          <Lock className="w-5 h-5 text-[#00e5ff]" />
        </div>
        <h1 className="text-2xl font-bold text-white mb-3" data-testid="access-denied-title">{c.title}</h1>
        <p className="text-sm text-[#9EB4C0] mb-8 leading-relaxed">{c.body}</p>
        <a
          href={BACKOFFICE_URL}
          className="inline-flex items-center gap-2 rounded-full px-6 py-3 font-bold text-[#040816] bg-gradient-to-r from-[#0051ff] to-[#00e5ff] hover:shadow-lg hover:shadow-[#00e5ff]/40 transition-shadow"
          data-testid="access-denied-backoffice-link"
        >
          {c.cta}
          <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
};
